/* src/app/public/public-form/public-form.component.scss */
.public-form-container {
  min-height: 98vh;
  padding: 0;
  font-family:
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    "Helvetica Neue",
    Arial,
    sans-serif;
}
.public-form-container .loading-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background:
    linear-gradient(
      135deg,
      #f5f7fa 0%,
      #c3cfe2 100%);
}
.public-form-container .loading-content {
  text-align: center;
  animation: fadeIn 0.5s ease;
}
.public-form-container .loading-text {
  margin-top: 1.5rem;
  font-size: 1.125rem;
  color: #475569;
  font-weight: 500;
}
.public-form-container .error-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background:
    linear-gradient(
      135deg,
      #fff5f5 0%,
      #fed7d7 100%);
}
.public-form-container .error-card {
  background: white;
  border-radius: 20px;
  padding: 3rem;
  max-width: 500px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  animation: slideUp 0.5s ease;
}
.public-form-container .error-icon-wrapper {
  width: 80px;
  height: 80px;
  margin: 0 auto 1.5rem;
  background:
    linear-gradient(
      135deg,
      #fee2e2 0%,
      #fca5a5 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.public-form-container .error-icon-wrapper i {
  font-size: 2.5rem;
  color: #dc2626;
}
.public-form-container .error-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.75rem;
}
.public-form-container .error-message {
  font-size: 1.125rem;
  color: #64748b;
  margin-bottom: 0.5rem;
}
.public-form-container .error-hint {
  font-size: 0.875rem;
  color: #94a3b8;
}
.public-form-container .success-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background:
    linear-gradient(
      135deg,
      #f0fdf4 0%,
      #bbf7d0 100%);
}
.public-form-container .success-card {
  background: white;
  border-radius: 20px;
  padding: 3rem;
  max-width: 500px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  animation: slideUp 0.5s ease;
}
.public-form-container .success-animation {
  margin-bottom: 2rem;
}
.public-form-container .success-checkmark {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  background:
    linear-gradient(
      135deg,
      #10b981 0%,
      #059669 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: scaleIn 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.public-form-container .success-checkmark i {
  font-size: 3rem;
  color: white;
  animation: checkmark 0.5s 0.3s ease forwards;
  opacity: 0;
}
.public-form-container .success-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 1rem;
}
.public-form-container .success-message {
  font-size: 1.125rem;
  color: #64748b;
  margin-bottom: 0.5rem;
}
.public-form-container .success-subtitle {
  font-size: 0.9375rem;
  color: #94a3b8;
  margin-bottom: 2rem;
}
.public-form-container .submit-another-btn {
  background: white;
  border: 2px solid #e2e8f0;
  color: #475569;
  padding: 0.875rem 2rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
}
.public-form-container .submit-another-btn:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}
.public-form-container .submit-another-btn:active {
  transform: translateY(0);
}
.public-form-container .form-wrapper {
  display: flex;
  flex-direction: column;
  height: 98vh;
  max-width: 900px;
  margin: auto;
  animation: fadeIn 0.5s ease;
  padding-top: 0px;
  overflow: hidden;
}
.public-form-container .form-header {
  flex-shrink: 0;
  background: #033162;
  padding: 1.5rem 2rem;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.15);
}
.public-form-container .header-content {
  text-align: left;
}
.public-form-container .form-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: white;
  margin-bottom: 0.5rem;
  line-height: 1.3;
}
.public-form-container .form-description {
  font-size: 0.9375rem;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
  margin: 0;
}
.public-form-container .form-content-scroll {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  background: white;
  scrollbar-width: thin;
}
.public-form-container .form-content-scroll::-webkit-scrollbar {
  width: 8px;
}
.public-form-container .form-content-scroll::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}
.public-form-container .form-content-scroll::-webkit-scrollbar-thumb {
  border-radius: 10px;
}
.public-form-container .form-card {
  padding: 2.5rem;
}
.public-form-container .form-row {
  margin-bottom: 2rem;
  animation: fadeInUp 0.5s ease;
}
.public-form-container .form-row:last-of-type {
  margin-bottom: 0;
}
.public-form-container .form-field {
  animation: fadeIn 0.5s ease;
}
.public-form-container .field label {
  display: block;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #334155;
  margin-bottom: 0.5rem;
}
.public-form-container .field label .text-red-500 {
  color: #ef4444;
  margin-left: 0.25rem;
}
.public-form-container .field small {
  display: block;
  font-size: 0.8125rem;
  margin-top: 0.375rem;
}
.public-form-container .field small.text-gray-500 {
  color: #64748b;
}
.public-form-container .field small.text-red-500 {
  color: #ef4444;
  font-weight: 500;
}
.public-form-container .form-footer-fixed {
  flex-shrink: 0;
  background: white;
  border-top: 2px solid #f1f5f9;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
  border-radius: 0 0 20px 20px;
}
.public-form-container .footer-content {
  padding: 1.5rem 2.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
}
.public-form-container .footer-security {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  font-size: 0.875rem;
  color: #64748b;
  flex: 1;
}
.public-form-container .footer-security i {
  font-size: 1.125rem;
  color: #10b981;
  flex-shrink: 0;
}
.public-form-container .footer-security span {
  line-height: 1.4;
}
.public-form-container .form-actions {
  display: flex;
  gap: 1rem;
  flex-shrink: 0;
}
.public-form-container .btn-reset,
.public-form-container .btn-submit {
  padding: 0.875rem 2rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  border: none;
  outline: none;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}
.public-form-container .btn-reset i,
.public-form-container .btn-submit i {
  font-size: 1rem;
}
.public-form-container .btn-reset:disabled,
.public-form-container .btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.public-form-container .btn-reset:disabled:hover,
.public-form-container .btn-submit:disabled:hover {
  transform: none;
  box-shadow: none;
}
.public-form-container .btn-reset:hover:not(:disabled),
.public-form-container .btn-submit:hover:not(:disabled) {
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4);
  transform: translateY(-2px);
}
.public-form-container .btn-reset:active:not(:disabled),
.public-form-container .btn-submit:active:not(:disabled) {
  transform: translateY(0);
}
.public-form-container .btn-reset.loading,
.public-form-container .btn-submit.loading {
  opacity: 0.8;
}
.public-form-container .no-form-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background:
    linear-gradient(
      135deg,
      #f3f4f6 0%,
      #e5e7eb 100%);
}
.public-form-container .no-form-card {
  background: white;
  border-radius: 20px;
  padding: 3rem;
  max-width: 500px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  animation: slideUp 0.5s ease;
}
.public-form-container .no-form-icon-wrapper {
  width: 80px;
  height: 80px;
  margin: 0 auto 1.5rem;
  background:
    linear-gradient(
      135deg,
      #dbeafe 0%,
      #93c5fd 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.public-form-container .no-form-icon-wrapper i {
  font-size: 2.5rem;
  color: #2563eb;
}
.public-form-container .no-form-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 0.75rem;
}
.public-form-container .no-form-message {
  font-size: 1.125rem;
  color: #64748b;
  margin-bottom: 0.5rem;
  line-height: 1.6;
}
.public-form-container .no-form-hint {
  font-size: 0.875rem;
  color: #94a3b8;
  line-height: 1.5;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes scaleIn {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
@keyframes checkmark {
  from {
    opacity: 0;
    transform: scale(0);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.public-form-container .form-footer {
  text-align: center;
  margin-top: 1.5rem;
  padding: 1rem;
}
.public-form-container .footer-text {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #94a3b8;
}
.public-form-container .footer-text i {
  font-size: 1rem;
  color: #10b981;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes scaleIn {
  from {
    transform: scale(0);
  }
  to {
    transform: scale(1);
  }
}
@keyframes checkmark {
  from {
    opacity: 0;
    transform: scale(0);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.public-form-container :host ::ng-deep .p-inputtext,
.public-form-container :host ::ng-deep .p-inputtextarea,
.public-form-container :host ::ng-deep .p-inputnumber-input,
.public-form-container :host ::ng-deep .p-calendar input,
.public-form-container :host ::ng-deep .p-dropdown,
.public-form-container :host ::ng-deep .p-multiselect {
  width: 100%;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  padding: 0.75rem 1rem;
  font-size: 0.9375rem;
  color: #1e293b;
  background: white;
  transition: all 0.2s ease;
}
.public-form-container :host ::ng-deep .p-inputtext:hover:not(:disabled),
.public-form-container :host ::ng-deep .p-inputtextarea:hover:not(:disabled),
.public-form-container :host ::ng-deep .p-inputnumber-input:hover:not(:disabled),
.public-form-container :host ::ng-deep .p-calendar input:hover:not(:disabled),
.public-form-container :host ::ng-deep .p-dropdown:hover:not(:disabled),
.public-form-container :host ::ng-deep .p-multiselect:hover:not(:disabled) {
  border-color: #cbd5e1;
}
.public-form-container :host ::ng-deep .p-inputtext:focus,
.public-form-container :host ::ng-deep .p-inputtext.p-focus,
.public-form-container :host ::ng-deep .p-inputtextarea:focus,
.public-form-container :host ::ng-deep .p-inputtextarea.p-focus,
.public-form-container :host ::ng-deep .p-inputnumber-input:focus,
.public-form-container :host ::ng-deep .p-inputnumber-input.p-focus,
.public-form-container :host ::ng-deep .p-calendar input:focus,
.public-form-container :host ::ng-deep .p-calendar input.p-focus,
.public-form-container :host ::ng-deep .p-dropdown:focus,
.public-form-container :host ::ng-deep .p-dropdown.p-focus,
.public-form-container :host ::ng-deep .p-multiselect:focus,
.public-form-container :host ::ng-deep .p-multiselect.p-focus {
  border-color: #667eea;
  box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
  outline: none;
}
.public-form-container :host ::ng-deep .p-inputtext::placeholder,
.public-form-container :host ::ng-deep .p-inputtextarea::placeholder,
.public-form-container :host ::ng-deep .p-inputnumber-input::placeholder,
.public-form-container :host ::ng-deep .p-calendar input::placeholder,
.public-form-container :host ::ng-deep .p-dropdown::placeholder,
.public-form-container :host ::ng-deep .p-multiselect::placeholder {
  color: #94a3b8;
}
.public-form-container :host ::ng-deep .p-inputtext.ng-invalid.ng-dirty,
.public-form-container :host ::ng-deep .p-inputtextarea.ng-invalid.ng-dirty,
.public-form-container :host ::ng-deep .p-inputnumber-input.ng-invalid.ng-dirty,
.public-form-container :host ::ng-deep .p-calendar input.ng-invalid.ng-dirty,
.public-form-container :host ::ng-deep .p-dropdown.ng-invalid.ng-dirty,
.public-form-container :host ::ng-deep .p-multiselect.ng-invalid.ng-dirty {
  border-color: #ef4444;
}
.public-form-container :host ::ng-deep .p-inputtext.ng-invalid.ng-dirty:focus,
.public-form-container :host ::ng-deep .p-inputtextarea.ng-invalid.ng-dirty:focus,
.public-form-container :host ::ng-deep .p-inputnumber-input.ng-invalid.ng-dirty:focus,
.public-form-container :host ::ng-deep .p-calendar input.ng-invalid.ng-dirty:focus,
.public-form-container :host ::ng-deep .p-dropdown.ng-invalid.ng-dirty:focus,
.public-form-container :host ::ng-deep .p-multiselect.ng-invalid.ng-dirty:focus {
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1);
}
.public-form-container :host ::ng-deep .p-inputtextarea {
  resize: vertical;
  min-height: 100px;
}
.public-form-container :host ::ng-deep .p-dropdown .p-dropdown-trigger {
  color: #64748b;
}
.public-form-container :host ::ng-deep .p-dropdown .p-dropdown-label {
  padding: 0.75rem 1rem;
}
.public-form-container :host ::ng-deep .p-dropdown-panel {
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
  border: 1px solid #e2e8f0;
  margin-top: 0.5rem;
}
.public-form-container :host ::ng-deep .p-dropdown-panel .p-dropdown-items {
  padding: 0.5rem;
}
.public-form-container :host ::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item {
  padding: 0.75rem 1rem;
  border-radius: 8px;
  transition: all 0.2s ease;
}
.public-form-container :host ::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item:hover {
  background: #f8fafc;
}
.public-form-container :host ::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
  background:
    linear-gradient(
      135deg,
      rgba(102, 126, 234, 0.1) 0%,
      rgba(118, 75, 162, 0.1) 100%);
  color: #667eea;
}
.public-form-container :host ::ng-deep .p-multiselect .p-multiselect-label {
  padding: 0.75rem 1rem;
}
.public-form-container :host ::ng-deep .p-multiselect .p-multiselect-trigger {
  color: #64748b;
}
.public-form-container :host ::ng-deep .p-multiselect-panel {
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
  border: 1px solid #e2e8f0;
  margin-top: 0.5rem;
}
.public-form-container :host ::ng-deep .p-multiselect-panel .p-multiselect-items {
  padding: 0.5rem;
}
.public-form-container :host ::ng-deep .p-multiselect-panel .p-multiselect-items .p-multiselect-item {
  padding: 0.75rem 1rem;
  border-radius: 8px;
  transition: all 0.2s ease;
}
.public-form-container :host ::ng-deep .p-multiselect-panel .p-multiselect-items .p-multiselect-item:hover {
  background: #f8fafc;
}
.public-form-container :host ::ng-deep .p-multiselect-panel .p-multiselect-items .p-multiselect-item.p-highlight {
  background:
    linear-gradient(
      135deg,
      rgba(102, 126, 234, 0.1) 0%,
      rgba(118, 75, 162, 0.1) 100%);
  color: #667eea;
}
.public-form-container :host ::ng-deep .p-checkbox .p-checkbox-box {
  width: 20px;
  height: 20px;
  border: 2px solid #cbd5e1;
  border-radius: 6px;
  transition: all 0.2s ease;
}
.public-form-container :host ::ng-deep .p-checkbox .p-checkbox-box:hover {
  border-color: #667eea;
}
.public-form-container :host ::ng-deep .p-checkbox .p-checkbox-box.p-highlight {
  background:
    linear-gradient(
      135deg,
      #667eea 0%,
      #764ba2 100%);
  border-color: #667eea;
}
.public-form-container :host ::ng-deep .p-checkbox .p-checkbox-box.p-highlight .p-checkbox-icon {
  color: white;
}
.public-form-container :host ::ng-deep .p-radiobutton .p-radiobutton-box {
  width: 20px;
  height: 20px;
  border: 2px solid #cbd5e1;
  transition: all 0.2s ease;
}
.public-form-container :host ::ng-deep .p-radiobutton .p-radiobutton-box:hover {
  border-color: #667eea;
}
.public-form-container :host ::ng-deep .p-radiobutton .p-radiobutton-box.p-highlight {
  border-color: #667eea;
}
.public-form-container :host ::ng-deep .p-radiobutton .p-radiobutton-box.p-highlight .p-radiobutton-icon {
  background:
    linear-gradient(
      135deg,
      #667eea 0%,
      #764ba2 100%);
}
.public-form-container :host ::ng-deep .p-calendar .p-inputtext {
  padding-right: 2.5rem;
}
.public-form-container :host ::ng-deep .p-calendar .p-datepicker-trigger {
  color: #64748b;
}
.public-form-container :host ::ng-deep .p-datepicker {
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
  border: 1px solid #e2e8f0;
}
.public-form-container :host ::ng-deep .p-datepicker .p-datepicker-header {
  background:
    linear-gradient(
      135deg,
      #667eea 0%,
      #764ba2 100%);
  color: white;
  border-radius: 12px 12px 0 0;
  padding: 1rem;
}
.public-form-container :host ::ng-deep .p-datepicker table {
  font-size: 0.9375rem;
}
.public-form-container :host ::ng-deep .p-datepicker table td {
  padding: 0.25rem;
}
.public-form-container :host ::ng-deep .p-datepicker table td > span {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 8px;
  transition: all 0.2s ease;
}
.public-form-container :host ::ng-deep .p-datepicker table td > span:not(.p-highlight):hover {
  background: #f8fafc;
}
.public-form-container :host ::ng-deep .p-datepicker table td > span.p-highlight {
  background:
    linear-gradient(
      135deg,
      #667eea 0%,
      #764ba2 100%);
  color: white;
}
.public-form-container :host ::ng-deep .p-inputnumber .p-inputnumber-button {
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #475569;
  transition: all 0.2s ease;
}
.public-form-container :host ::ng-deep .p-inputnumber .p-inputnumber-button:hover {
  background: #f1f5f9;
}
.public-form-container :host ::ng-deep .p-progress-spinner-circle {
  stroke: #667eea;
  animation: dash 1.5s ease-in-out infinite;
}
.public-form-container :host ::ng-deep .p-toast .p-toast-message {
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
}
.public-form-container :host ::ng-deep .p-toast .p-toast-message.p-toast-message-success {
  background:
    linear-gradient(
      135deg,
      #10b981 0%,
      #059669 100%);
}
.public-form-container :host ::ng-deep .p-toast .p-toast-message.p-toast-message-error {
  background:
    linear-gradient(
      135deg,
      #ef4444 0%,
      #dc2626 100%);
}
.public-form-container :host ::ng-deep .p-toast .p-toast-message.p-toast-message-info {
  background:
    linear-gradient(
      135deg,
      #3b82f6 0%,
      #2563eb 100%);
}
.public-form-container :host ::ng-deep .p-toast .p-toast-message.p-toast-message-warn {
  background:
    linear-gradient(
      135deg,
      #f59e0b 0%,
      #d97706 100%);
}
@media (max-width: 768px) {
  .public-form-container .form-container {
    padding: 1rem;
  }
  .public-form-container .form-header {
    padding: 1.25rem 1.5rem;
  }
  .public-form-container .header-content {
    text-align: left;
  }
  .public-form-container .form-title {
    font-size: 1.5rem;
  }
  .public-form-container .form-description {
    font-size: 0.875rem;
  }
  .public-form-container .form-card {
    padding: 1.5rem;
  }
  .public-form-container .footer-content {
    flex-direction: column;
    padding: 1.25rem 1.5rem;
    gap: 1rem;
  }
  .public-form-container .footer-security {
    text-align: center;
    justify-content: center;
    font-size: 0.8125rem;
  }
  .public-form-container .form-actions {
    width: 100%;
    flex-direction: column;
  }
  .public-form-container .form-actions .btn-reset,
  .public-form-container .form-actions .btn-submit {
    width: 100%;
    justify-content: center;
  }
  .public-form-container .form-footer-fixed {
    border-radius: 0;
  }
  .public-form-container .error-card,
  .public-form-container .success-card {
    padding: 2rem;
  }
}
@media (max-width: 480px) {
  .public-form-container .form-header {
    padding: 1rem 1.25rem;
  }
  .public-form-container .form-title {
    font-size: 1.25rem;
  }
  .public-form-container .form-description {
    font-size: 0.8125rem;
  }
  .public-form-container .form-card {
    padding: 1.25rem;
  }
  .public-form-container .footer-content {
    padding: 1rem 1.25rem;
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  .public-form-container .form-wrapper {
    max-width: 800px;
  }
}
/*# sourceMappingURL=public-form.component.css.map */
